/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Edit, Trash2 } from 'lucide-react';
import AppLayout from '../../../Components/Layout/Layout';
import { TopActions } from '../../../Components/TopActions/TopActions';
import Pagination from '../../../Components/Pagination/Pagination';
import ApiService from '../../../Config/ApiConfig';
import { ListaUsuarios, UsuarioSd01Dto } from '../../../Dtos/Cadastros/Usuarios/UsuariosDtos';
import { useNavigate } from 'react-router-dom';
import { ConfirmeDialog } from '../../../Components/ConfirmeDialog/ConfirmeDialog';
import LoadingPage from '../../../Components/Loading/Loading';

const ListaUsuariosPage: React.FC = () => {
    const navigate = useNavigate()
    const [sd01s, setSd01s] = useState<UsuarioSd01Dto[]>([])
    const [filter, setFilter] = useState('');
    const [quantity, setQuantity] = useState('13');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        async function checkApi() {
            try {
                const apiService = new ApiService();

                const response = await apiService.get<boolean>("/auth/temAcesso", { params: { tarefa: "Usuarios" } })

                if (!response) {
                    navigate("/home");
                }
            } catch (error) {
                navigate("/home");
            }
        }

        checkApi();
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        buscarUsuarios()
    }, [currentPage, quantity, filter])

    const buscarUsuarios = async () => {
        try {
            setLoading(true)

            const apiService = new ApiService();

            const sd01s = await apiService.get<ListaUsuarios>("/sd01Controller/listarUsuarios", {
                params: {
                    currentPage,
                    qtd: quantity,
                    filter: filter
                }
            })

            const pages = Math.ceil(sd01s.count / Number(quantity));


            setSd01s(sd01s.values)
            setTotalPage(pages)

        } catch (error) {
        } finally {
            setLoading(false)
        }
    }

    const handleEdit = (id: number) => {
        navigate("/usuario/" + id)
    };

    const handleDelete = async (id: number) => {
        try {
            setLoading(true)

            const apiService = new ApiService();
            await apiService.delete("/sd01Controller/excluirUsuario",{
                params:{
                    'sd01id': id
                }
            })
            await buscarUsuarios()
        } catch (error) {
        } finally {
            setLoading(false)
        }
    };

    const handleAddNew = () => {
        navigate("/usuario")
    };

    const handleFiltrar = (filtro: string, qtd: string) => {
        setFilter(filtro);
        setQuantity(qtd);
    }

    const renderMobileView = () => (
        <CardView>
            {sd01s.map(sd01 => (
                <UserCard key={sd01.sd01id}>
                    <CardField>
                        <label>Login</label>
                        <span>{sd01.sd01login}</span>
                    </CardField>
                    <CardField>
                        <label>Nome</label>
                        <span>{sd01.sd01nome}</span>
                    </CardField>
                    <CardField>
                        <label>Email</label>
                        <span>{sd01.sd01email}</span>
                    </CardField>
                    <CardActions>
                        <ActionButton onClick={() => handleEdit(sd01.sd01id!)}>
                            <Edit size={16} />
                        </ActionButton>
                        <ActionButton className="delete" onClick={() => handleDelete(sd01.sd01id!)}>
                            <Trash2 size={16} />
                        </ActionButton>
                    </CardActions>
                </UserCard>
            ))}
        </CardView>
    );

    const renderDesktopView = () => (
        <TableContainer>
            <Table>
                <thead>
                    <tr>
                        <Th>#</Th>
                        <Th>Login</Th>
                        <Th>Nome</Th>
                        <Th>Email</Th>
                        <Th>Operações</Th>
                    </tr>
                </thead>
                <tbody>
                    {sd01s.map(sd01 => (
                        <tr key={sd01.sd01id}>
                            <Td>{sd01.sd01id}</Td>
                            <Td>{sd01.sd01login}</Td>
                            <Td>{sd01.sd01nome}</Td>
                            <Td>{sd01.sd01email}</Td>
                            <Td className="actions">
                                <ActionButton onClick={() => handleEdit(sd01.sd01id!)}>
                                    <Edit size={16} />
                                </ActionButton>
                                <ConfirmeDialog
                                    message='Excluir usuario?'
                                    onCancel={() => { }}
                                    onConfirm={() => handleDelete(sd01.sd01id!)}
                                    trigger={
                                        <ActionButton className="delete">
                                            <Trash2 size={16} />
                                        </ActionButton>
                                    }
                                />
                            </Td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </TableContainer>
    );
    if(loading){
        return (
            <LoadingPage />
        )
    }
    return (
        <AppLayout>
            <TopActions
                filter={filter}
                quantity={quantity}
                handleAddNew={handleAddNew}
                filtrar={handleFiltrar}
            />
            {isMobile ? renderMobileView() : renderDesktopView()}

            <Pagination
                currentPage={currentPage}
                totalPages={totalPage}
                onPageChange={setCurrentPage}
            />
        </AppLayout>
    );
};

const breakpoints = {
    mobile: '480px',
    tablet: '768px',
    laptop: '1024px'
};

const TableContainer = styled.div`
    overflow-x: auto;
    background: white;
    border-radius: 4px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  
    @media (max-width: ${breakpoints.mobile}) {
      border-radius: 0;
      margin: 0 -10px;
    }
  `;

const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
    min-width: 600px;
  `;

const Th = styled.th`
    background: #f5f5f5;
    padding: 12px 16px;
    text-align: left;
    font-weight: 600;
    color: #333;
    border-bottom: 2px solid #ddd;
    white-space: nowrap;
  `;

const Td = styled.td`
    padding: 12px 16px;
    border-bottom: 1px solid #eee;
    color: #666;
  
    &.actions {
      display: flex;
      gap: 8px;
    }
  `;

const ActionButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    padding: 4px;
    color: #666;
    transition: color 0.2s;
  
    &:hover {
      color: ${props => props.className?.includes('delete') ? '#DC1E2D' : '#1e88e5'};
    }
  `;

const CardView = styled.div`
    display: none;
    
    @media (max-width: ${breakpoints.tablet}) {
      display: block;
    }
  `;

const UserCard = styled.div`
    background: white;
    border-radius: 4px;
    padding: 16px;
    margin-bottom: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  `;

const CardField = styled.div`
    margin-bottom: 8px;
    
    label {
      font-size: 12px;
      color: #999;
      display: block;
      margin-bottom: 4px;
    }
    
    span {
      color: #333;
    }
  `;

const CardActions = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 12px;
    padding-top: 12px;
    border-top: 1px solid #eee;
  `;

export default ListaUsuariosPage;